import { CSSObject } from '@emotion/react';
import { useHoneycombTheme } from '../../../theming';

type StyleClasses = 'root' | 'label' | 'chevron';

export function useStyles(): {
    styles: { [key in StyleClasses]: CSSObject };
} {
    const { theme } = useHoneycombTheme();

    const { Accordion: componentTheme } = theme.components.themes;
    const chevronSize = `${componentTheme.chevronSize}px`;

    const root: CSSObject = {
        display: 'flex',
        gap: `${componentTheme.paddingX}px`,
        alignItems: 'center',
        padding: `0 ${componentTheme.paddingX}px`,
        ...theme.fn.focusStyles(),
    };

    const label: CSSObject = {
        flex: 1,
        padding: `${componentTheme.headerPaddingY}px 0`,
    };

    const chevron: CSSObject = {
        display: 'inline-block',
        fill: 'currentColor',
        width: chevronSize,
        height: chevronSize,
        transition: `transform ${theme.transitions.duration.standard}ms ease`,

        '&[data-rotate]': {
            transform: 'rotate(180deg)',
        },
    };

    return {
        styles: {
            root,
            label,
            chevron,
        },
    };
}
